import { createSlice } from "@reduxjs/toolkit";

import {
  fetchActivitiesList,
  fetchBerthrotationDataByJobId,
} from "../thunks/activityThunks";

import type { Activity } from "../../utils/types/activities";
import type { PayloadAction } from "@reduxjs/toolkit";

interface ActivitiesState {
  activityList: Activity[];
  selectedActivity: Activity | null;
  loading: boolean;
  berthData: any[];
  error: string | null;
  total: number; // New property for total activities
}

const initialState: ActivitiesState = {
  activityList: [],
  selectedActivity: null,
  loading: false,
  berthData: [], // Add a new property to hold berth rotation data for the selected activity
  error: null,
  total: 0,
};

const activitiesSlice = createSlice({
  name: "activities",
  initialState,
  reducers: {
    getActivityList(state, action: PayloadAction<Activity>) {
      state.selectedActivity = action.payload;
    },
    clearSelectedActivity(state) {
      state.selectedActivity = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivitiesList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchActivitiesList.fulfilled,
        (state, action: PayloadAction<{ data: Activity[]; total: number }>) => {
          state.loading = false;
          state.activityList = action.payload.data || [];
          state.total = action.payload.total;
        }
      )
      .addCase(fetchActivitiesList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
    builder
      .addCase(fetchBerthrotationDataByJobId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBerthrotationDataByJobId.fulfilled, (state, action) => {
        state.loading = false;
        state.berthData = action.payload; // Update with fetched data
      })
      .addCase(fetchBerthrotationDataByJobId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default activitiesSlice.reducer;

export const { getActivityList, clearSelectedActivity } =
  activitiesSlice.actions;
